"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drawStrokeSegment = exports.drawSegment = exports.degToRad = exports.getCanvasContext = void 0;
/**
 * Set up the properties of a canvas element.
 */

var getCanvasContext = function getCanvasContext(canvasDomElement) {
  var dpr = window.devicePixelRatio || 1;
  var rect = canvasDomElement.getBoundingClientRect(); // Give the canvas pixel dimensions of their CSS
  // size * the device pixel ratio.

  canvasDomElement.width = rect.width * dpr;
  canvasDomElement.height = rect.height * dpr;
  var ctx = canvasDomElement.getContext('2d');
  ctx.scale(dpr, dpr);
  return ctx;
};

exports.getCanvasContext = getCanvasContext;

var degToRad = function degToRad(degree) {
  return Math.PI / 180 * (degree - 90);
};
/**
 * Draw a segment.
 */


exports.degToRad = degToRad;

var drawSegment = function drawSegment(ctx, x, y, radius, startDegree, endDegree) {
  ctx.beginPath();
  ctx.moveTo(x, y); // arc(x, y, radius, startAngle, endAngle, anticlockwise)

  ctx.arc(x, y, radius, degToRad(startDegree), degToRad(endDegree), false);
  ctx.lineTo(x, y);
};

exports.drawSegment = drawSegment;

var drawStrokeSegment = function drawStrokeSegment(ctx, x, y, startDeg, endDeg, innerRadius, outerRadius, fill) {
  var lineWidth = outerRadius - innerRadius;
  ctx.beginPath();
  ctx.strokeStyle = fill;
  ctx.lineWidth = lineWidth;
  ctx.arc(x, y, outerRadius - lineWidth / 2, degToRad(startDeg), degToRad(endDeg));
  ctx.stroke();
};

exports.drawStrokeSegment = drawStrokeSegment;